let schema = require("js-schema");

module.exports = schema({
  domain: /.*(.io|.com)$/,
  port: Number,
  path: String,
  query: String,
  protocol: /http|https/
});
